import React from 'react';
import Menu from '../Menu/Menu';
import Projects from '../Projects/Projects';

const Home = () => {
    return (
        <div>
            <Menu></Menu>
            <Projects></Projects>
        </div>
    );
};

export default Home;